module.exports = __webpack_public_path__ + "static/media/16 PROVEN WAYS - OVATO EBOOK.8edc9427.pdf";